import "./Login.scss";

import React, { useCallback, useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";

import Alert from "../../components/Alert";
import Logo from "../../components/Logo";
import { isRunningInFront } from "../../services/front";
import { auth } from "../../services/GoogleAuth";
import { redirectFromLogin } from "../../services/routing";
import { GOOGLE_DOMAINS } from "../../utils/constants";

const Login = () => {
  const [error, setError] = useState(null);
  const navigate = useNavigate();
  const location = useLocation();

  const handleAuthSuccess = useCallback(
    user => {
      const domain = user.getHostedDomain();

      if (!domain || !GOOGLE_DOMAINS.includes(domain)) {
        return auth.signOut().then(() => {
          setError(`This account is not an Airsorted/Houst Google account. 
          Please log out of this account on any tabs you may have open (e.g. Gmail) and try again.`);
        });
      }

      redirectFromLogin(navigate, location);
    },
    [navigate, location]
  );

  useEffect(() => {
    const handleAuthFailure = () => {
      setError("Failed to log in, please try again.");
    };

    if (isRunningInFront || auth.isSignedIn()) {
      navigate("/");
    }

    window.gapi.signin2.render("login-button", {
      scope: "profile email",
      theme: "light",
      longtitle: true,
      onsuccess: handleAuthSuccess,
      onfailure: handleAuthFailure
    });
  }, [navigate, handleAuthSuccess]);

  return (
    <div className="Login">
      <Logo />

      <h3>Airbox Messenger</h3>

      {error && (
        <div className="Login__error">
          <Alert
            title={"Something went wrong..."}
            message={error}
            status="fail"
            type="block"
          />
        </div>
      )}

      <div className="Login__button">
        <div id="login-button">
          <p>
            <i>Loading...</i>
          </p>
        </div>
      </div>
    </div>
  );
};

export default Login;
